export const isNone = (v: unknown) =>
  v == null || v === "" || v === 0 || v === "0";

export const scalarChanged = (a: unknown, b: unknown) =>
  !(isNone(a) && isNone(b)) && String(a ?? "") !== String(b ?? "");

export const featuresChanged = (a: unknown, b: unknown) => {
  const norm = (v: unknown) =>
    Array.isArray(v) ? [...(v as string[])].sort() : [];
  return JSON.stringify(norm(a)) !== JSON.stringify(norm(b));
};

export const SHARED_FIELD = {
  bedrooms: "bedrooms",
  bathrooms: "bathrooms",
  houseFeatures: "houseFeatures",
  location: "location",
  petFriendly: "petFriendly",
  contract: "contract",
  smokingAllowed: "smokingAllowed",
} as const;

export type SharedFieldKey = (typeof SHARED_FIELD)[keyof typeof SHARED_FIELD];

export const SHARED_FIELD_KEYS: SharedFieldKey[] = Object.values(SHARED_FIELD);

export const BOOL_SHARED_FIELDS: SharedFieldKey[] = [
  SHARED_FIELD.petFriendly,
  SHARED_FIELD.contract,
  SHARED_FIELD.smokingAllowed,
];

export type SharedValues = {
  bedrooms?: number | string | null;
  bathrooms?: number | string | null;
  houseFeatures?: string[];
  locationNormalizedName?: string | null;
  petFriendly?: boolean | null;
  contract?: boolean | null;
  smokingAllowed?: boolean | null;
};

export const isSharedFieldDefined = (
  values: SharedValues,
  key: SharedFieldKey,
): boolean => {
  if (key === SHARED_FIELD.houseFeatures)
    return (values.houseFeatures?.length ?? 0) > 0;
  if (key === SHARED_FIELD.location) return !!values.locationNormalizedName;
  return values[key] != null;
};

export const sharedFieldChanged = (
  a: SharedValues,
  b: SharedValues,
  key: SharedFieldKey,
): boolean => {
  if (key === SHARED_FIELD.houseFeatures)
    return featuresChanged(a.houseFeatures, b.houseFeatures);
  if (key === SHARED_FIELD.location)
    return scalarChanged(a.locationNormalizedName, b.locationNormalizedName);
  if (BOOL_SHARED_FIELDS.includes(key))
    return Boolean(a[key]) !== Boolean(b[key]);
  return scalarChanged(a[key], b[key]);
};
